import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Helmet } from '../components/Helmet';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page non trouvée | Upnov IA</title>
        <meta
          name="description"
          content="Page non trouvée. Revenez à l'accueil pour découvrir nos formations en IA pour entreprises."
        />
      </Helmet>

      <div className="min-h-[80vh] flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-6xl font-bold text-primary mb-8">404</h1>
          <h2 className="text-2xl font-semibold mb-4">Page non trouvée</h2>
          <p className="text-gray-600 mb-8">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary">
              <Home className="mr-2 h-5 w-5" />
              Retour à l'accueil
            </Link>
            <button onClick={() => window.history.back()} className="btn-secondary">
              <ArrowLeft className="mr-2 h-5 w-5" />
              Page précédente
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;